export default __webpack_public_path__ + "static/media/040-trailer.b930f745.svg";